import React from "react";

export default function SpotifyIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M12 .082c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.628 0 12-5.373 12-12s-5.372-12-12-12Zm5.503 17.307a.748.748 0 0 1-1.029.248c-2.817-1.72-6.364-2.11-10.541-1.156a.748.748 0 0 1-.333-1.46c4.571-1.043 8.492-.594 11.655 1.34a.748.748 0 0 1 .248 1.028Zm1.469-3.267a.936.936 0 0 1-1.287.308c-3.226-1.982-8.142-2.557-11.958-1.399a.937.937 0 0 1-1.167-.623.937.937 0 0 1 .624-1.167c4.358-1.322 9.776-.681 13.48 1.595.44.27.579.846.308 1.286Zm.126-3.403C15.23 8.422 8.849 8.211 5.157 9.332a1.122 1.122 0 1 1-.652-2.148c4.24-1.287 11.286-1.038 15.738 1.605a1.121 1.121 0 1 1-1.145 1.93Z"
      />
    </svg>
  );
}
